export enum EClassCode {
  NotApplicable = 'notApplicable',
  First = 'first',
  Second = 'second',
  Tourist = 'tourist',
  Comfort = 'comfort',
  Premium = 'premium',
  Business = 'business',
  All = 'all',
  PremiumFirst = 'premiumFirst',
  StandardFirst = 'standardFirst',
  PremiumSecond = 'premiumSecond',
  StandardSecond = 'standardSecond',
}

export const classCodeMap = {
  '1. Klasse': EClassCode.First,
  '2. Klasse': EClassCode.Second,
};
